"use strict";
exports.__esModule = true;
exports.ZoomLevel = void 0;
var ZoomLevel;
(function (ZoomLevel) {
    ZoomLevel[ZoomLevel["AREA"] = 0] = "AREA";
    ZoomLevel[ZoomLevel["DISTRICT"] = 1] = "DISTRICT";
    ZoomLevel[ZoomLevel["BUILDING"] = 2] = "BUILDING";
    ZoomLevel[ZoomLevel["PROPERTY"] = 3] = "PROPERTY";
})(ZoomLevel = exports.ZoomLevel || (exports.ZoomLevel = {}));
